import { IApp } from '@/types/nuxt'
import { LogType, errors } from '@tokyojob/frontend-core'
import { IVacancy, IVacancyDetails, LanguageLocale } from '@tokyojob/core'
import { getAppStore } from '~/store/app.store'

/**
 * Parameters used during the request.
 */
export interface GetVacancyParams {
  /**
   * Id of the vacancy to get.
   */
  id: string

  /**
   * Whether a candidate is currently logged in or not.
   */
  candidateIsLoggedIn?: boolean

  /**
   * The id of the selected visa type, if any.
   * Used to help find other related jobs.
   */
  visaTypeId?: number

  /**
   * The locale required
   */
  locale?: LanguageLocale
}

export default class GetUseCase implements BaseUsecase {
  app: IApp
  constructor(app: IApp) {
    this.app = app
  }

  async execute(params: GetVacancyParams): Promise<IVacancyDetails | null> {
    const { baseGateway, logService, state } = this.app
    try {
      return baseGateway.vacancy.Get(params.id, params.visaTypeId, params.locale, state.formattedFilters)
    } catch (error) {
      await logService.handle({ type: LogType.Error, error: error as Error })
      const appStore = getAppStore()
      appStore.setErrors(errors(error))
      return null
    }
  }
}
